import { Grid, RadioGroup } from '@mui/material';
import { TrainingAutoCompleteDataModel } from 'components/MprcAutoComplete/AutoCompleteDataModel';
import { MprcRadio } from 'components/MprcRadio';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ManagedTrainingAutoComplete } from 'views/lms/training/components/ManagedTrainingAutoComplete';

////////////////////////////////////////////////////////////////////////////

interface IProps {
    onError: (e: any) => void;
    onItemsChange: (members: string[]) => void;
}

type TrainingGroupType = "approvedUsers" | "enrolledUsers" | "attendingUsers";

////////////////////////////////////////////////////////////////////////////

export const AddTraining: React.FC<IProps> = (props) => {

    const { onItemsChange, onError } = props;
    const { t } = useTranslation("knowledge");

    const [selectedItem, setSelectedItem] = useState<TrainingAutoCompleteDataModel>();
    const [trainingGroupType, setTrainingGroupType] = useState<TrainingGroupType>("approvedUsers");

    ////////////////////////////////////////////////////////////////////////////
    ///
    const onChange = (item: TrainingAutoCompleteDataModel[]) => {
        if (item.length > 0) {
            setSelectedItem(item[0]);
        } else {
            setSelectedItem(undefined);
        }
    };

    ////////////////////////////////////////////////////////////////////////////

    useEffect(() => {

        const members = [];
        if (selectedItem != undefined) {
            if (trainingGroupType == "approvedUsers")
                members.push(selectedItem!.approvedUsersGroup.id);
            else if (trainingGroupType == "enrolledUsers")
                members.push(selectedItem!.enrolledUsersGroup.id);
            else if (trainingGroupType == "attendingUsers")
                members.push(selectedItem!.attendingUsersGroup.id);
        }

        onItemsChange(members);
    }, [selectedItem, trainingGroupType]);

    return <Grid container spacing={2} direction="column">
        <Grid>
            <ManagedTrainingAutoComplete
                autoFocus
                placeholder={t("Channel.Edit.Members.SelectTrainingPlaceholder")}
                multiSelect={false}
                onChange={onChange}
                onError={onError}
                selectedItems={selectedItem ? [selectedItem] : []}
            />
        </Grid>
        <Grid>
            <RadioGroup
                value={trainingGroupType}
                onChange={(e, value) => setTrainingGroupType(value as TrainingGroupType)}
            >
                <MprcRadio
                    label={t("Channel.Edit.Members.TrainingEnrolledUsersLabel")}
                    helperText={t("Channel.Edit.Members.TrainingEnrolledUsersHint")}
                    value={"enrolledUsers"}
                />
                <MprcRadio
                    label={t("Channel.Edit.Members.TrainingInProgressUsersLabel")}
                    value={"attendingUsers"}
                />
                <MprcRadio
                    label={t("Channel.Edit.Members.TrainingApprovedUsersLabel")}
                    value={"approvedUsers"}
                />
            </RadioGroup>
        </Grid>
    </Grid>;
};
